import { Grid, Link } from "@mui/material";

export default function InvoiceFormThanksPage() {
    const handleClick = (event) => {
        event.preventDefault(); // Prevent default link behavior
        window.history.back();
    };
    return (
        <Grid
            container
            justifyContent={"center"}
            alignItems={"center"}
            height={"100%"}
            textAlign={"center"}
        >
            <Grid item>
                <h2>Your invoice submission was successful!</h2>
                <Link href={"#"} onClick={handleClick}>
                    Send another?
                </Link>
            </Grid>
        </Grid>
    );
}
